'use strict';

(function (angular) {
    angular.module('zp').directive('scrollTop', scrollTop);

    /**@ngInject */
    function scrollTop($window) {
        return {
            restrict: 'E',
            link: link,
            replace: true,
            templateUrl: 'app/scroll.top/scroll.top.html',
            scope: {}
        };

        function link(scope) {
            scope.showScroller = false;

            scope.scrollToTop = scrollToTop;

            (function () {
                angular.element($window).bind("scroll", function () {
                    if (this.pageYOffset >= 10) {
                        scope.showScroller = true;
                    } else {
                        scope.showScroller = false;
                    }
                    scope.$apply();
                });
            })();

            function scrollToTop() {
                $window.scrollTo(0, 0);
            }
        }
    }
})(window.angular);